import actions from '~/store/modules/shared/dealers/map/actions'
import getters from '~/store/modules/shared/dealers/map/getters'
import mutations from '~/store/modules/shared/dealers/map/mutations'
import state from '~/store/modules/shared/dealers/map/state'
import { createModule } from '~/factories/store'

export default createModule({
  actions,
  getters,
  mutations,
  state
})
